module.exports = __webpack_public_path__ + "img/4195529.png";